import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { CompanyDto, ExternalJobDto, ExternalJobPositionDto, HiringStateDto, LookupDto, MatchedLeadsProductDto } from 'app/models/dtos';
import { environment } from 'environments/environment';
import { stripHtml } from 'string-strip-html';

@Component({
  selector: 'app-job-details-card',
  templateUrl: './job-details-card.component.html',
  // styleUrls: ['./job-details-card.component.css']
})
export class JobDetailsCardComponent implements OnInit {

  //inputs
  @Input() company: CompanyDto;
  @Input() product: MatchedLeadsProductDto;
  @Input() job: ExternalJobDto;
  @Input() showMap: boolean = false;

  //vars
  positions: ExternalJobPositionDto[] = [];

  constructor(
    private http: HttpClient
  ) { }

  ngOnInit(): void {
   this.getJobPositions();
  }

  getJobPositions(): void {
    //necessary to retain job board re-use of this component
    if (this.job.positions) {
      if (this.job.positions.length > 0) {
          this.positions = this.job.positions;
          this.showMap = true;
          return;
      }
    }

    //in normal circumstances, we will fetch the job positions
    this.http
          .get(`${environment.services_tdusa_admin}/v1/companies/${this.company.id}/matchedLeadsProducts/${this.product.id}/jobs/${this.job.id}/positions`)
          .subscribe((result: ExternalJobPositionDto[]) => {
            this.positions = result;
            this.showMap = true;
            // this.viewState = ViewState.content;
          });
  }

  formattedDescription(): string {
    return stripHtml(this.job.descriptionHtml ?? '').result.substring(0, 100);
  }

  statePositions(): ExternalJobPositionDto[] {
    return this.positions.filter(p => p.hiringZip == null && p.hiringCity == null && p.hiringState);
  }

  cityPositions(): ExternalJobPositionDto[] {
    return this.positions.filter(p => p.hiringZip == null && p.hiringCity != null);
  }

  zipPositions(): ExternalJobPositionDto[] {
    return this.positions.filter(p => p.hiringZip != null);
  }

  lookupList(type: LookupDto[]): string {
    return type.map(t => t.name)
    .join(', ');
  }

  statesList(): string {
    return this.statePositions()
    .filter(t => t.hiringState)
      .map(t => t.hiringState.abbreviation)
      .join(', ');
  }
}
